(function () {

    "use strict";

    // Created with "angular-toastr": "1.7.0"

    angular
        .module("stToast", [
            "toastr"
        ])
        .factory("stToastFactory", toastFactory);

    function toastFactory(toastr) {

        return {
            success: success,
            info: info,
            error: error,
            errorHandler: errorHandler
        }


        function success(title, message) {
            toastr.success(message, title, {
                allowHtml: true
            });
        }


        function info(title, message) {
            toastr.info(`${message} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>(Click this message to close it.)</i>`, title, {
                allowHtml: true,
                closeButton: true,
                autoDismiss: false,
                tapToDismiss: true,
                hoverToClose: false,
                timeOut: 0,
                extendedTimeOut: 0
            });
        }

        function error(title, message) {
            toastr.error(`${message} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>(Click this message to close it.)</i>`, title, {
                allowHtml: true,
                closeButton: true,
                autoDismiss: false,
                tapToDismiss: true,
                hoverToClose: false,
                timeOut: 0,
                extendedTimeOut: 0
            });
        }

        /// error - javascript error - required
        /// title - string for title - optional
        function errorHandler(err, title) {
            if (!err || !err.status) {
                console.log("stToastFactory.errorHandler called with invalid parameters", err, title);
                return;
            }

            if (err.status === 400) {
                const tit = title ||"Information";
                let msg = err.statusText; // data.Message
                if (err.data && err.data.Message)
                    msg = err.data.Message;
                console.log(`${tit} ${msg}`, err);
                info(tit, msg);
            } else {
                const tit = title || "Error";
                const msg = "Something went wrong and it was logged. If you need further support please contact the help desk.";
                console.log(`${tit} ${msg}`, err);
                error(tit, msg);
            }
        }

    }

    toastFactory.$inject = ["toastr"];

})();